export default __webpack_public_path__ + "static/media/login-2.7588c53d.svg";